export const getSuggestedRules = t => [
  {
    id: 1,
    content: t('CAPTAIN.ASSISTANTS.SUGGESTED_RULES.SENSITIVE_INFORMATION'),
  },
  {
    id: 2,
    content: t('CAPTAIN.ASSISTANTS.SUGGESTED_RULES.OFFENSIVE_LANGUAGE'),
  },
  {
    id: 3,
    content: t('CAPTAIN.ASSISTANTS.SUGGESTED_RULES.MEDICAL_LEGAL_ADVICE'),
  },
];
